




































import { Component, Prop, Vue } from 'vue-property-decorator'
import FuncaoDescricao from '@/factories/ProfissionalExecutanteFuncaoDescricao'

@Component

export default class ComponentRelatorioEquipe extends Vue {
  @Prop(Object) procedimento

  showEquipe: Boolean = false

  FuncaoDescricao(grau) {
    return FuncaoDescricao.funcao(grau)
  }
}
